import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from "@/utils/Cookies";
import { removeToken } from "@/utils/auth";

Vue.use(Vuex)

import {getUserAuth} from "@/api/public"
export default new Vuex.Store({
  state: {
    filterList:'',
    boothList:'',
    count:0,
    authList:[]
  },
  mutations: {
    SET_AUTH: (state, auth) => {
      state.authList = auth
    },
  },
  actions: {
    // 获取用户权限信息
    getAuth({ commit }){
      return new Promise((resolve, reject) => {
        getUserAuth().then(res=>{
          resolve(res.data)
        }).catch(err=>{
          reject()
        })
      })
    }
  },
  modules: {
  }
})
